import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import TermosDeUso from "../pages/termos-de-uso/page";
import PoliticaDePrivacidade from "../pages/politica-de-privacidade/page";
import AdminPage from "../pages/admin/page";
import ImplementacaoPage from "../pages/implementacao/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/termos-de-uso",
    element: <TermosDeUso />,
  },
  {
    path: "/politica-de-privacidade",
    element: <PoliticaDePrivacidade />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "/implementacao",
    element: <ImplementacaoPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
